export const setCookieWithOneYearExpiration = (name, value) =>{
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1); // Adiciona 1 ano à data atual
    const expires = "expires=" + date.toUTCString(); // Converte a data para o formato UTC
    document.cookie = `${name}=${value}; ${expires}; path=/`; // Define o cookie
}

export const getCookie = (name) => {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}